import axiosInstance from "./axiosInstance";

function buildQueryString(params) {
  return Object.entries(params)
    .filter(([_, v]) => v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}

export const getRaceTopList = async (params) => {
  const query = buildQueryString(params);
  return axiosInstance.get(`race-top/find-all?${query}`);
};

export const createRaceTop = async (payload) => {
  // payload: { site, account, ranking, type_game_id, product_type_id }
  return axiosInstance.post("race-top/create", payload);
};

export const updateRaceTopStatus = async (id) => {
  return axiosInstance.patch(`race-top/update-status/${id}`);
};

export const deleteRaceTop = async (account) => {
  return axiosInstance.delete(
    `race-top/delete?account=${encodeURIComponent(account)}`
  );
};

export const exportRaceTopExcel = async (site) => {
  return axiosInstance.post(
    `race-top/download-data?site=${encodeURIComponent(site)}`,
    {},
    { responseType: "blob" }
  );
};
